'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var EARTH_TAXONOMY_ID = '58f7ed51dadb30820bb38782';

// eslint-disable-next-line import/prefer-default-export
exports.EARTH_TAXONOMY_ID = EARTH_TAXONOMY_ID;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/TaxonomyNavigator/constants.js
// module id = 182
// module chunks = 0